import _ from 'lodash'

const attributesSchema = {
    ARRAN: {
        name: 'Arranque sin llave',
        order: 1
    },
    CAMES: {
        name: 'Cámara de estacionamiento',
        order: 2
    },
    CDASI: {
        name: 'Capacidad de asientos',
        order: 3
    },
    QPUERTAS: {
        name: 'Cantidad de puertas',
        order: 4
    },
    CAPAR: {
        name: 'Capacidad de arrastre',
        unit: 'Kg',
        order: 5
    },
    CAPCA: {
        name: 'Capacidad de carga',
        unit: 'Kg',
        order: 6
    },
    CLIMAT: {
        name: 'Climatizador por zona',
        order: 7
    },
    DDSUE: {
        name: 'Despeje del suelo ',
        unitConcatenated: '(cm)',
        order: 8
    },
    FILAS: {
        name: 'N° de filas de asientos',
        order: 9
    },
    LLANT: {
        name: 'Llantas',
        concatenated: 'NEDEL',
        unitConcatenated: '',
        order: 10
    },
    LDPRO: {
        name: 'Llave de proximidad',
        order: 11
    },
    PANTR: {
        name: 'Pantalla para pasajeros traseros',
        order: 12
    },
    POTEN: {
        name: 'Potencia máxima',
        unit: 'bhp',
        order: 13
    },
    ISOFIX: {
        name: 'Puntos de anclaje del asiento para niños',
        order: 14
    },
    SENSESTA: {
        name: 'Sensores de estacionamiento',
        order: 15
    },
    SUDEL: {
        name: 'Suspensión delantera',
        order: 16
    },
    SUTRA: {
        name: 'Suspensión trasera',
        order: 17
    },
    TECHCOR: {
        name: 'Techo corredizo',
        order: 18
    },
    TECHPAN: {
        name: 'Techo panorámico',
        order: 19
    },
    TADAS: {
        name: 'Tecnología ADAS',
        order: 20
    },
    TORQU: {
        name: 'Par/Torque máximo',
        unit: 'Nm',
        order: 21
    },
    VEMAX: {
        name: 'Velocidad máxima',
        unit: 'km/h',
        order: 22
    },
    VOLCA: {
        name: 'Volumen de carga',
        unit: 'm3',
        order: 23
    }
}

const yesNoValues = {
    yes: 'Sí',
    no: 'No'
}

const formatAttribute = (attribute, attSchema, attSchemaConcatenated) => {
    if (typeof attribute === 'boolean') {
        return attribute ? yesNoValues.yes : yesNoValues.no
    }

    if (attSchema.unit) attribute += ` ${attSchema.unit}`

    if (attSchema.concatenated) {
        const concatValue = attSchemaConcatenated
        const concatUnit = attSchema.unitConcatenated

        if (concatValue) attribute += ` ${concatValue}`
        if (concatUnit) attribute += ` ${attSchema.unitConcatenated}`
    }

    return attribute
}

export const getRelevantAttributes = (carData, attributesBySegment) => {
    if (!attributesBySegment) return []

    if (!carData.SEGMENTO || carData.SEGMENTO === 'Otro') return []
    if (!carData.attributesBySegment) return []

    return attributesBySegment
        .filter(att => att in attributesSchema)
        .filter(att => !!carData[att])
        .map(attribute => {
            const attSchema = attributesSchema[attribute]

            return {
                name: attSchema.name,
                unit: attSchema.unit,
                value: carData[attribute],
                formattedValue: formatAttribute(carData[attribute], attSchema, carData[attSchema.concatenated]),
                order: attSchema.order
            }
        })
}

export const getInitialRelevantAttributes = (cards) => {
    let result = []
    cards.forEach(item => {
        const attributes = getRelevantAttributes(
            item.vehicleDetails?.data?.vehicle,
            item.vehicleDetails?.data?.vehicle.attributesBySegment
        )
        if (item.vehicleDetails) {
            result = [...result, attributes]
        }
    })

    let dataReturn = []
    const attNames = _.uniq(_.flatten(result).sort((a, b) => a.order - b.order).map(a => a.name))
    result.map(dataCar => {
        dataReturn = [...dataReturn, attNames.map(attribute => {
            const att = dataCar.filter(at => attribute === at.name)
            const noData = { name: attribute, formattedValue: '-' }
            return (att.length === 0) ? noData : att[0]
        })]
    })

    return dataReturn
}
